<script setup lang="ts">
import { storeToRefs } from 'pinia'
import { useAdminStore } from '@/stores/admin'
import AppIcon from './AppIcon.vue'

const store = useAdminStore()
const { toasts } = storeToRefs(store)
</script>

<template>
  <Teleport to="body">
    <div class="toast-host" aria-live="polite" aria-relevant="additions">
      <article v-for="toast in toasts" :key="toast.id" class="toast" :class="`toast--${toast.tone}`">
        <div class="toast__icon">
          <AppIcon :name="toast.tone === 'success' ? 'check' : toast.tone === 'error' ? 'alert' : 'info'" :size="18" />
        </div>
        <div><strong>{{ toast.title }}</strong><p>{{ toast.message }}</p></div>
        <button type="button" aria-label="Tutup pemberitahuan" @click="store.dismissToast(toast.id)"><AppIcon name="close" :size="17" /></button>
      </article>
    </div>
  </Teleport>
</template>
